const common = {}

common.install = function (Vue, options) {

  const data = {
    lang : window.lang,
    statusList: {
      'all' : '전체',
      'pre': '예정된 경기',
      'live': '라이브 경기',
    },
    sportsCategory : [
      {
        id : '',
        text : '전체',
        class : ''
      },
      {
        id : 1,
        text : '축구',
        class : 'soccer'
      },
      {
        id : 2,
        text : '야구',
        class : 'baseball'
      },
      {
        id : 3,
        text : '농구',
        class : 'basketball'
      },
      {
        id : 4,
        text : '배구',
        class : 'volleyball'
      },
      {
        id : 5,
        text : '하키',
        class : 'icehockey'
      },
    ],
    mypageCategory : [
      {
        id : '',
        text : '전체'
      },
      {
        id : 2,
        text : '진행중'
      },
      {
        id : 3,
        text : '종료'
      },
    ],
    gameResult :{
      win : '승리',
      loss : '패배',
      ready : '결과 대기중',
      draw : '적중 특례'
    }
  }

  const methods = {
    popupNickname: function (nickname) {
      window.open('/mypage/namecard.php?nickname=' + nickname, '', 'width=620,height=720,scrollbars=no,resizable=no');
    },
    numberToString: function (value) {
      if (typeof value !== 'number') {
        return '';
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closePopup: function () {
      this.isShow = false;
      $('._layer_background').hide();
    },
    async _get(url, params, callback) {
      try {
        return await this.$http.get(url, {
          params: params
        });
      } catch (e) {
        console.log('*** error ***');
        console.log(e);
        this.errorAlert(callback)
      }
    },
    async _post(url, params, callback) {
      try {
        return await this.$http.post(url, params);
      } catch (e) {
        console.log('*** error ***');
        console.log(e);
        this.errorAlert(callback)
      }
    },
    async _put(url, params, callback) {
      try {
        return await this.$http.put(url, params);
      } catch (e) {
        console.log('*** error ***');
        console.log(e);
        this.errorAlert(callback)
      }
    },
    async _delete(url, params, callback) {
      try {
        return await this.$http.delete(url, {params:params});
      } catch (e) {
        console.log('*** error ***');
        console.log(e);
        this.errorAlert(callback)
      }
    },
    errorAlert (callback) {
      if (callback) {
        callback()
        return false;
      }

      alert("정상적으로 처리하지 못하였습니다.");
      return false;
    }
  }

  const computed = {
    tradeType: function () {
      return this.$route.query.tradeType ? this.$route.query.tradeType : 'SELL';
    },
    tradeTypeText: function () {
      return this.tradeType === 'SELL' ? '연승포기' : '연승도전'
    },
  }

  Vue.mixin({
    methods: methods,
    computed : computed,
    data: function () {
      return data
    },
  })
}

export default common



// WEBPACK FOOTER //
// ./src/mixins/common.js